import {isValidPrimaryBeneficiary , PrimaryBeneficiary} from 'ApplicationEntry/models/PrimaryBeneficiary';
import * as I from 'immutable';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class InvalidPrimaryBeneficiaryList {
  public readonly key = 'InvalidPrimaryBeneficiaryList';

  constructor(public readonly primaryBeneficiaryList: I.List<PrimaryBeneficiary>) {}
}

export class ValidPrimaryBeneficiaryList {
  public static create(primaryBeneficiaryList: I.List<PrimaryBeneficiary>) {
    const primaryBeneficiaryListArrayLength = primaryBeneficiaryList.size;
    const haveAtLeastOnePrimaryBeneficiary = primaryBeneficiaryListArrayLength > 0;

    return haveAtLeastOnePrimaryBeneficiary ? new ValidPrimaryBeneficiaryList(primaryBeneficiaryList) : new InvalidPrimaryBeneficiaryList(primaryBeneficiaryList);
  }

  public readonly key = 'ValidPrimaryBeneficiaryList';
  private constructor(public readonly primaryBeneficiaryList: I.List<PrimaryBeneficiary>) {}
}

export type PrimaryBeneficiaryList = InvalidPrimaryBeneficiaryList | ValidPrimaryBeneficiaryList;

export type PrimaryBeneficiaryListOptions<TReturn> = ToPartialMatchOptions<PrimaryBeneficiaryList, 'key', TReturn>;

export const matchPrimaryBeneficiaryList = <TReturn>(options: PrimaryBeneficiaryListOptions<TReturn>) => (app: PrimaryBeneficiaryList): TReturn => {
  switch (app.key) {
    case 'InvalidPrimaryBeneficiaryList':
      return options.InvalidPrimaryBeneficiaryList ? options.InvalidPrimaryBeneficiaryList(app) : options.default(app);
    case 'ValidPrimaryBeneficiaryList':
      return options.ValidPrimaryBeneficiaryList ? options.ValidPrimaryBeneficiaryList(app) : options.default(app);
  }
};

export const addPrimaryBeneficiary = (primaryBeneficiary: I.List<PrimaryBeneficiary>) => (primaryBeneficiaryList: I.List<PrimaryBeneficiary>) => {
  const existingList: I.List<PrimaryBeneficiary> = primaryBeneficiaryList;
  const newPrimaryBeneficiaryList = existingList.concat(primaryBeneficiary).filter(isValidPrimaryBeneficiary);

  return ValidPrimaryBeneficiaryList.create(newPrimaryBeneficiaryList);
};

export const removePrimaryBeneficiary = (index: number) => (primaryBeneficiaryList: I.List<PrimaryBeneficiary>) => {
  const existingList: I.List<PrimaryBeneficiary> = primaryBeneficiaryList;
  const newPrimaryBeneficiaryList = existingList.delete(index);

  return ValidPrimaryBeneficiaryList.create(newPrimaryBeneficiaryList);
};

export const updatePrimaryBeneficiary = (primaryBeneficiary: PrimaryBeneficiary, index: number) => (primaryBeneficiaryList: I.List<PrimaryBeneficiary>) => {
  const existingList: I.List<PrimaryBeneficiary> = primaryBeneficiaryList;
  let newPrimaryBeneficiaryList: I.List<PrimaryBeneficiary> = existingList;
  if (isValidPrimaryBeneficiary(primaryBeneficiary)) {
    newPrimaryBeneficiaryList = existingList.splice(index, 1, primaryBeneficiary);
  }

  return ValidPrimaryBeneficiaryList.create(newPrimaryBeneficiaryList);
};

export const EmptyPrimaryBeneficiaryList = new InvalidPrimaryBeneficiaryList(I.List<PrimaryBeneficiary>());
export const MAX_PRIMARY_BENEFICIARIES = 8;